import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetch, store } from "../../../utils/httpUtil";

export const searchMembersWithCriteria = createAsyncThunk(
  "members/search",
  async (payload) => {
    try {
      const response = await store("v1/members/search", payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const addMembers = createAsyncThunk("members/add", async (payload) => {
  try {
    const response = await store("v1/members", payload);
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
});

export const updateMembers = createAsyncThunk(
  "update/members",
  async (payload) => {
    try {
      const response = await store(`v1/members/${payload?.id}/update`, payload?.payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchMembersByID = createAsyncThunk(
  "members/detail",
  async (id) => {
    try {
      const response = await fetch(`v1/members/${id}/detail`);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchUpdateRequest = createAsyncThunk(
  "members/update-request",
  async (id) => {
    try {
      const response = await fetch(`v1/members/${id}/update-request`);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

const listPending = ["members/search/pending"];
const listFulfilled = ["members/search/fulfilled"];
const listRejected = ["members/search/rejected"];

const detailPending = [
  "members/detail/pending",
  "members/add/pending",
  "update/members/pending",
  "members/update-request/pending",
];
const detailFulfilled = [
  "members/detail/fulfilled",
  "members/add/fulfilled",
  "update/members/fulfilled",
  "members/update-request/fulfilled",
];
const detailRejected = [
  "members/detail/rejected",
  "members/add/rejected",
  "update/members/rejected",
  "members/update-request/rejected",
];

export const membersSlice = createSlice({
  name: "members",
  initialState: {
    membersPayload: [],
    membersLoading: false,
    membersErrors: {},
    membersPagination: {},

    membersDetailPayload: [],
    membersDetailLoading: false,
    membersDetailErrors: {},
  },
  reducers: {
    cleanMembers(state) {
      state.membersPayload = [];
      state.membersLoading = false;
      state.membersErrors = {};
      state.membersPagination = {};
    },
    cleanDetails(state) {
      state.membersDetailPayload = [];
      state.membersDetailLoading = false;
      state.membersDetailErrors = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) => listPending.includes(action.type),
        (state) => {
          state.membersLoading = true;
        }
      )
      .addMatcher(
        (action) => listFulfilled.includes(action.type),
        (state, action) => {
          state.membersLoading = false;
          state.membersPayload = action.payload?.data;
          state.membersPagination = action.payload?.pagination;
        }
      )
      .addMatcher(
        (action) => listRejected.includes(action.type),
        (state, action) => {
          state.membersLoading = false;
          state.membersErrors = action.error;
        }
      )
      .addMatcher(
        (action) => detailPending.includes(action.type),
        (state) => {
          state.membersDetailLoading = true;
        }
      )
      .addMatcher(
        (action) => detailFulfilled.includes(action.type),
        (state, action) => {
          state.membersDetailLoading = false;
          state.membersDetailPayload = action.payload?.data;
        }
      )
      .addMatcher(
        (action) => detailRejected.includes(action.type),
        (state, action) => {
          state.membersDetailLoading = false;
          state.membersDetailErrors = action.error;
        }
      );
  },
});

export const { cleanMembers, cleanDetails } = membersSlice.actions;
export default membersSlice;
